import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { initializeIcons } from '@fluentui/react'

import Chat from './pages/chat/Chat'
import ChatPopup from './pages/chat/ChatPopup'
import Layout from './pages/layout/Layout'
import NoPage from './pages/NoPage'
import EmbedDemo from './pages/EmbedDemo'
import { AppStateProvider } from './state/AppProvider'

import './index.css'
import './i18n'

initializeIcons("https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/icons/")

export default function App() {
  return (
    <AppStateProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Chat />} />
          </Route>
          <Route path="/chatpopup" element={<ChatPopup />} />
          <Route path="/embed-demo" element={<EmbedDemo />} />
          <Route path="*" element={<NoPage />} />
        </Routes>
      </HashRouter>
    </AppStateProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
